var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 48,
    viewBox: "0 0 30 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#568958;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "things_to_do") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map_pin_fill"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.33,4.91A14.6,14.6,0,0,0,4.67,25.56S15,35.68,15,47.37c0-11.68,10.33-21.8,10.33-21.8A14.6,14.6,0,0,0,25.33,4.91Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.73,8.56a2,2,0,1,0-2-2A2,2,0,0,0,16.73,8.56ZM13,12,10.11,26.38h2.14l1.83-8.15,2.14,2v6.11h2V18.74l-2.14-2,.61-3.05a7.46,7.46,0,0,0,5.6,2.55v-2A5,5,0,0,1,18,11.71l-1-1.63a2.1,2.1,0,0,0-1.73-1c-.31,0-.51.1-.81.1L9.09,11.41v4.79h2V12.73L13,12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.02739352fa5875cac862650c16631745.svg";
export { ForwardRef as ReactComponent };